import { Directive } from '@angular/core';
import { ControlContainer } from '@angular/forms';

@Directive({
  selector: '[appAutocompleteFormBoundary]',
  standalone: false,
  providers: [{ provide: ControlContainer, useValue: null }],
})
export class AutocompleteFormBoundaryDirective {}
